import { acceptHMRUpdate, defineStore } from 'pinia'

export const useToastsStore = defineStore({
    id: 'toasts',
    state: () => {
        return {
            toasts: [],
        }
    },
    actions: {
        addToast(payload) {
            const id = Math.random().toString(36).substr(2, 9);
            payload.id = id;
            this.toasts.push(payload);

            if (payload.autoClose) {
                setTimeout(() => {
                   this.removeToast({ id });
                }, 5000);
            }
        },
        removeToast(payload) {
            this.toasts = this.toasts.filter((t) => t.id !== payload.id);
        },
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useToastsStore, import.meta.hot))
}